import { addRecentlyCompletedTask } from "shared-ui";

import { CONNECT_APP_ROUTE_PATHS } from "../components/constants";

import { getAirOriginPath } from "./air-origin-path";

export const handleCompletedCustomerTaskForSession = (airPublicId: string, pathname: string) => {
  const airOrigin = getAirOriginPath(pathname);

  const isTasksOrigin = airOrigin
    ? [CONNECT_APP_ROUTE_PATHS.CUSTOMER_TASKS, CONNECT_APP_ROUTE_PATHS.ADDITIONAL_FUNDING].includes(
        airOrigin as CONNECT_APP_ROUTE_PATHS
      )
    : false;

  if (isTasksOrigin) {
    addRecentlyCompletedTask(airPublicId);
  }

  return;
};
